// extracted by mini-css-extract-plugin
export default {"stores":"SEGIAF","stores__image":"z0lVKP","stores__ios-adapt":"dreo1q","stores__android-adapt":"S1tMRC","stores__icon":"Rg9o1B","stores__icon-full-width":"yMYq_h"};